/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import qs from "qs";
import { api } from "../../api/httpClient";
import { buildUrl } from "../../../utils/bindUrl";
import { IListParams } from "@/interfaces/serviceInterface";
import {
  IResponseListSLAs,
  IResponseShowSLA,
  ISLA,
} from "../../../interfaces/slas";

const BASE = "/slas";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listSLAs({
  filter,
  includes,
  page,
  limit,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListSLAs>(BASE, {
    params: { filter, includes, page, limit, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showSLA({
  id,
  includes,
}: {
  id: string | number;
  includes?: string[];
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowSLA>(url, {
    params: { includes },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createSLA({ sla }: { sla: ISLA }) {
  const { data } = await api.post<IResponseShowSLA>(BASE, { sla });
  return data;
}

export async function updateSLA({
  id,
  sla,
}: {
  id: string | number;
  sla: ISLA;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowSLA>(url, { sla });
  return data;
}

export async function deleteSLA({ id }: { id: string | number }) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  // validateStatus => true evita cair no interceptor de erro (toast automático)
  const resp = await api.delete(url, { validateStatus: () => true });
  return { status: resp.status, data: resp.data };
}
